// SidebarDrawerStyles.js
import { styled } from '@mui/system';
import { ListItem } from '@mui/material';
import { NAVBAR_HEIGHT } from './Navbar'; // Ajusta la ruta si es necesario

export const DrawerContent = styled('div')(({ theme, isOpen }) => ({
    width: '60px', // Ancho fijo para mostrar solo iconos
    paddingTop: NAVBAR_HEIGHT,
    background: '#000057',
    color: '#fff',
    fontFamily: '"Arial", sans-serif',
    fontWeight: 'bold',
    transition: 'width 0.3s ease-in-out',
    '&:hover': {
      width: '240px', // Expandir al pasar el mouse
    },
    }));
export const StyledListItem = styled(ListItem)(({ theme, selected }) => ({
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)', // Efecto hover sutil
    },
    backgroundColor: selected ? 'rgba(255, 255, 255, 0.1)' : 'transparent', // Cambia el color de fondo si está seleccionado
    color: selected ? '#fff' : 'rgba(255, 255, 255, 0.7)' ,
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    padding: theme.spacing(2),
    transition: 'all 0.2s ease-in-out',
}));